import { FC, useMemo } from "react";
import { AppBar as MuiAppBar, Typography } from "@mui/material";
import { APP_NAME } from "@/constants/common";
import { ROUTES } from "@/routing/constants";
import { Currency } from "@/types/currency";
import { AppDrawer } from "@/components/AppDrawer";
import { useSearchParams } from "react-router-dom";
import * as Styled from "./AppBar.styles";

const DEFAULT_CURRENCY = Currency.USD;

export const AppBar: FC = () => {
  const [searchParams] = useSearchParams();

  const queryObject = useMemo(() => {
    return Object.fromEntries(searchParams.entries());
  }, [searchParams]);

  return (
    <MuiAppBar position="static">
      <Styled.Toolbar>
        <Styled.Wrapper>
          <Typography variant="h6" noWrap>
            {APP_NAME}
          </Typography>
          <Styled.Nav>
            <Styled.NavLink to={ROUTES.main.createURL(queryObject)}>
              Deposit
            </Styled.NavLink>
            <Styled.NavLink
              to={ROUTES.withdrawal.createURL({
                defaultCurrency: DEFAULT_CURRENCY,
                ...queryObject,
              })}
            >
              Withdrawal
            </Styled.NavLink>
          </Styled.Nav>
        </Styled.Wrapper>
        <AppDrawer />
      </Styled.Toolbar>
    </MuiAppBar>
  );
};
